<mat-card class="mat-elevation-z8">
  <div class="row">
    <div class="col"></div>
    <div class="col-1">
      <!--<button mat-raised-button color="primary" (click)="hideTable()">Back</button>-->
    </div>

  </div>
  <form [formGroup]="product_group_register_form">
    <div class="form-group">
      <label>Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
      <input type="text" class="form-control" formControlName='name'>
    </div>
    <button mat-raised-button color="primary" (click)="registerProductGroup()"
            [disabled]="!product_group_register_form.valid" style="text-transform: capitalize">{{action}}</button>
  </form>
</mat-card>
